import { getPlatformApiUrl, platformGet, platformPost, platformPatch, platformDelete } from '@/core/api';
import { mapPlatformMeToSessionUser } from '@/core/auth/sessionMap';
import { passwordLogin } from '@/modules/auth/oidc/pkce';

/** Establish session from a bearer (OIDC access token or lab HMAC). */
export async function sessionFromBearer(accessToken) {
  const res = await fetch(`${getPlatformApiUrl()}/v1/me`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (!res.ok) {
    const body = await res.text();
    const err = new Error(body || `HTTP ${res.status}`);
    err.response = { status: res.status, data: body };
    throw err;
  }
  const envelope = await res.json();
  const me = envelope.data || envelope;
  return { access_token: accessToken, user: mapPlatformMeToSessionUser(me), me };
}

/** Username/email + password via IdP password grant, then platform /v1/me. */
export async function credentialLogin(username, password) {
  const tokens = await passwordLogin(username, password);
  return sessionFromBearer(tokens.access_token);
}

/** Lab dual-mode: paste or env lab token. */
export async function labTokenLogin(token) {
  return sessionFromBearer(String(token || '').trim());
}

export function fetchPlatformMe() {
  return platformGet('/v1/me');
}

export { platformGet, platformPost, platformPatch, platformDelete };
